import { withMVC } from '@tcp-base/design-system';
import useAuthCheckController from './AuthChecker.controller';
import { type AuthCheckerModel, type AuthCheckerProps } from './AuthChecker.model';
import AuthCheckViewer from './AuthChecker.viewer';

/**
 * Auth Checker Component (Simplified)
 *
 * Purpose: Check if access_token exists in IndexedDB and validate its expiration
 *
 * Behavior:
 * - Uses AuthChecker service for pure authentication state checking
 * - If URL contains 'code' parameter (OAuth callback): Skip token check
 * - If token doesn't exist or is expired: Redirect to login using AuthService
 * - If token is valid: Call onTokenValid callback
 *
 * No UI rendering - pure logic component that always redirects when needed
 */
export const AuthChecker = withMVC<AuthCheckerProps, AuthCheckerModel>({
  useController: useAuthCheckController,
  Viewer: AuthCheckViewer,
});

export default AuthChecker;
